
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/atencio",
      function () {
        return require("private-next-pages/corporatiu/atencio/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/atencio"])
      });
    }
  